export default "__VITE_ASSET__DQl8MySL__"